import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "discovers",
    object: "discover",
    header: [
      { text: "ID", value: "id" },
      { text: "Title", value: "title" },
      { text: "Short Description", value: "short_description" },
      { text: "Long Description", value: "long_description" },
      { text: "Category", value: "category_id" },
      { text: "Picture", value: "picture" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
